import { Box } from '@mui/material';

export const HoverModal = ({ open, children }) => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '90vw',
                maxWidth: '900px',
                maxHeight: 'min(1400px, 85vh)',
                display: open ? 'flex' : 'none',
                backgroundColor: 'white',
                opacity: 0.9,
                borderRadius: '8px',
                boxShadow:
                    '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
                zIndex: 1300,
                padding: '24px',
            }}
        >
            {children}
        </Box>
    );
};
